<template><div><h1>页面切换转场动画</h1>
<p>你可以注意到 demo 站点的切换动画，本质上是使用 <code>Vue</code> 的 <code>transition</code> 组件实现的。</p>
<ul>
<li>[ ] todo</li>
</ul>
</div></template><script>
export default {
  head: {"title":"页面切换转场动画 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-router-page-transition-290.vue?d5e49c5e